import { MDBBtn, MDBCardBody, MDBCardText, MDBCardTitle, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { Button } from 'reactstrap';
import 'react-quill/dist/quill.snow.css';
import { createAnnouncement, getAnnouncements } from '../services/classApiServices';
import { useAnalytics } from '../hooks/useAnalytics';

const availableIcons = [
    'dumbbell', 'running', 'swimmer', 'biking', 'heartbeat', "certificate", "cog", "cogs",
    'walking', 'apple-alt', 'weight', 'fire', 'clock', "award", "bicycle", "users", "user", "male", "female", "baby", "walking",
    'trophy', 'medal', 'star', 'crown', 'shield-alt', "hiking", "skating", "snowboarding", "atom", "book-open", "football-ball", "hand-holding-usd", "hands", "hands-helping",
    "cookie-bite", "brain", "broom", "bullseye", "camera", "car", "chalkboard-teacher", "baseball-ball", "book", "capsules", "chess-queen", "fist-raised"
];

function Announcements({ roleAccess }) {
    const { trackButtonClick } = useAnalytics();
    const [showAnnounce, setShowAnnounce] = useState(false);
    const [showIconModal, setShowIconModal] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        icon: ''
    });
    const [announcements, setAnnouncements] = useState([]);

    const handleIconSelect = (icon) => {
        setFormData({ ...formData, icon });
        setShowIconModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    console.log(announcements, 'announcements');

    useEffect(() => {
        const fetchAnnounceData = async () => {
            const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
            const res = await getAnnouncements(gymid)
            if (!res || res == "false") {
                return
            }
            const recinfo = await res.json();
            console.log(recinfo);
            if (recinfo.length > 0) {
                setAnnouncements(recinfo)
            }

        }
        fetchAnnounceData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.title || !formData.description) {
            alert('Please fill in all required fields');
            return;
        }

        try {
            const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
            const newAnnouncement = {
                id: announcements.length + 1,
                title: formData.title,
                description: formData.description,
                icon: formData.icon || 'bullhorn',
                gymid: gymid,
            };

            console.log(newAnnouncement, 'newAnnouncement');

            const res = await createAnnouncement(gymid, newAnnouncement)


            // For now, we'll just add it to local state
            setAnnouncements([newAnnouncement, ...announcements]);

            // Reset form and close modal
            setFormData({
                title: '',
                description: '',
                icon: ''
            });
            setShowAnnounce(false);
            await trackButtonClick("Announcement", "Announcement_posted", "staff", {});
            alert('Announcement posted successfully!');

        } catch (error) {
            console.error('Error posting announcement:', error);
            alert('Failed to post announcement');
        }
    };

    return (
        <> <MDBCardBody>
            <MDBCardTitle>
                <label>Announcements</label>
                {roleAccess?.announcements != 2 && <button
                    className="btn btn-primary mb-3"
                    onClick={() => setShowAnnounce(true)}
                >
                    Create Announcement
                </button>}
            </MDBCardTitle>
            <MDBCardText>
                <div className="bussiness-announcements-list" >
                    {announcements?.length > 0 ? announcements.map(announcement => (

                        <div className="bussiness-announcement-item" key={announcement._id}>
                            <div className="bussiness-announcement-icon">
                                <MDBIcon icon={announcement?.icon} />
                            </div>
                            <div className="bussiness-announcement-content">
                                <p className="bussiness-announcement-title">{announcement?.title}</p>
                                <div className="bussiness-announcement-text" dangerouslySetInnerHTML={{ __html: announcement.description }} />
                                {/* <p className="bussiness-announcement-text">Closed on August 15th for equipment upgrades</p> */}
                                <p className="bussiness-announcement-date">Posted: {new Date(announcement?.createdAt).toLocaleDateString("en-US", {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric"
                                })}</p>
                            </div>
                        </div>
                    )) :
                        <div className="bussiness-announcement-item">
                            No Announcements Found
                        </div>


                    }
                </div>
            </MDBCardText>
        </MDBCardBody >


            <MDBModal open={showAnnounce} onClose={() => setShowAnnounce(false)} tabIndex="-1">
                <MDBModalDialog size='lg'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Create Announcement</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setShowAnnounce(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="announcementTitle">Title:</label>
                                    <input
                                        type="text"
                                        id="announcementTitle"
                                        name="title"
                                        className="form-control"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        placeholder="Enter announcement title"
                                        required
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="announcementDesc">Description:</label>
                                    <ReactQuill
                                        theme="snow"
                                        value={formData.description}
                                        onChange={(value) => setFormData({ ...formData, description: value })}
                                        placeholder="Enter announcement details"
                                    />
                                </div>
                                <div className="d-flex align-items-center mb-3">
                                    {formData.icon ? (
                                        <>
                                            <MDBIcon icon={formData.icon} className="me-2" size="lg" />
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => setShowIconModal(true)}
                                            >
                                                Change Icon
                                            </Button>
                                        </>
                                    ) : (
                                        <Button
                                            variant="outline-primary"
                                            onClick={() => setShowIconModal(true)}
                                        >
                                            <MDBIcon icon="plus" className="me-1" />
                                            Select Icon
                                        </Button>
                                    )}
                                </div>
                                <div className="d-flex justify-content-end">
                                    <MDBBtn color="secondary" className="me-2" onClick={() => setShowAnnounce(false)}>
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn color="primary" type="submit">
                                        Post Announcement
                                    </MDBBtn>
                                </div>
                            </form>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal open={showIconModal} onClose={() => setShowIconModal(false)} >
                <MDBModalDialog size='lg'>
                    <MDBModalContent>
                        <MDBModalHeader closeButton>
                            <MDBModalTitle>Select an Icon</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setShowIconModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div className="d-flex flex-wrap">
                                {availableIcons.map((icon) => (
                                    <div
                                        key={icon}
                                        className="m-2 p-2 border rounded cursor-pointer"
                                        onClick={() => handleIconSelect(icon)}
                                        style={{ width: '60px', textAlign: 'center' }}
                                    >
                                        <MDBIcon icon={icon} size="2x" />
                                        <div className="small mt-1">{icon}</div>
                                    </div>
                                ))}
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog >
            </MDBModal >
            {/* </div> */}
        </>

    );
}

export default Announcements;